export const assignedType = {
  GET_ASSIGNED_ORDERS: "GET_ASSIGNED_ORDERS",
  REQUEST_ASSIGNED_BOOKING_DONE: "REQUEST_ASSIGNED_BOOKING_DONE",
  REQUEST_ASSIGNED_BOOKING: "REQUEST_ASSIGNED_BOOKING",
  GET_QUICK_SCHEDULE_ORDERS: "GET_QUICK_SCHEDULE_ORDERS",
};
